




















import { Component, Vue } from 'vue-property-decorator';
import { fetchMaps } from '@gruppe-adler/maps-frontend-utils';
import { MapMetaData } from '@gruppe-adler/maps-frontend-utils';
import GradMapItemVue from '@/components/Maps/MapItem.vue';

type partialMeta = Pick<MapMetaData, 'worldName'|'displayName'|'author'>;

@Component({
    components: {
        MapItem: GradMapItemVue,
    }
})
export default class MapsVue extends Vue {
    private maps: partialMeta[] = [];
    private error: boolean = false;
    private loading: boolean = false;
    private filter: string = '';

    private mounted() {
        this.fetchMaps();
    }

    private async fetchMaps() {
        this.loading = true;

        try {
            this.maps = await fetchMaps();
        } catch (err) {
            console.error(err);
            this.error = true;
        }

        this.loading = false;
    }

    private get filteredMaps(): partialMeta[] {
        if (this.filter === '') return this.maps;

        const lFilter = this.filter.toLowerCase();

        return this.maps.filter(map => map.displayName.toLowerCase().includes(lFilter));
    }

    private goToMap(map: partialMeta) {
        this.$router.push(`/${map.worldName}`);
    }
}
